import {MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class AccountService {
  DoGetAllMainAccount() {
    return service.peakRealTimeAPI
      .post("/api/Account/GetAllAccountByMerchantId", {}, SetHeaderService())
      .then((res) => {
        return res;
      })
  }
  DoGetMerchantMonitoringAccount() {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      language: i18n.locale,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetMerchantMonitoringAccount", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
  }
  DoSetMerchantMonitoringAccount(followingList: any) {
    const _input = {
      merchantId: MerchantId(),
      followingList: followingList,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/SetMerchantMonitoringAccount", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetMerchantMonitoringAccountByAccountIdList(followingList: any) {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      language: i18n.locale,
      followingList: followingList,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetMerchantMonitoringAccountByAccountIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new AccountService();
